<div mat-dialog-content style="max-width: 500px;">
  <h1 mat-dialog-title>Cryptocurrency payment <img src="assets/payment/coinbase.svg" /></h1>
  <p>
    You may now transfer your payment to our cryptocurrency account with Coinbase.
  </p>
  <p>
    Please proceed to transfer your cryptocurrency directly here:
  </p>
  <p class="button">
    <button id="payDirectly" mat-raised-button (click)="directTransfer()" color="primary">
         Cryptocurrency Transfer
    </button>
  </p>
</div>
